module.exports = __webpack_public_path__ + "dff3df89eb8a6cfff6d6ec73b2d4066e.fbx";